import { useEffect } from 'react';

function useCurrentQuestionLoad(learnosityApp, callback) {
  useEffect(() => {
    learnosityApp?.once('item:changing', (itemIndex) => {
      callback(itemIndex);
    });
  }, [learnosityApp]);

  return null;
}

export default useCurrentQuestionLoad;
